// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"576":"d80ee577","998":"d80ee577"}[chunkId] + ".chunk.css";
};